<template lang="pug">
#modal-alertas-socioambientais
    el-dialog(
        :visible.sync='show',
        :before-close='closeModal',
        title='Alertas Socioambientais',
        :close-on-click-modal='false'
    )
        span.aviso
            i.mdi.mdi-alert-circle.warning
            p
                | Os alertas são emitidos conforme o protocolo previamente configurado de acordo com as necessidades de cada cliente.<br/> Caso não haja protocolo configurado será utilizado o padrão Vega.

        el-form.filtro(v-model='filtro', label-position='top')
            el-form-item.mb-0(label='Camada')
                el-select(
                    size='mini',
                    v-model='filtro.camadas',
                    multiple,
                    placeholder='Selecione',
                    filterable,
                    remote,
                    reserve-keyword,
                    value-key='id',
                    ref='elselectinput'
                )
                    el-option(
                        v-for='camada in camadas',
                        :key='"camada" + camada.id',
                        :value='camada.id',
                        :label='camada.nome'
                    ) {{ camada.nome }}

            el-form-item(label='Tipo')
                el-radio-group(v-model='filtro.tipo')
                    el-radio(label='Entrada/Atualização', value='INCONFORME')
                    el-radio.space-radio(label='Saída', value='CONFORME')

            el-form-item(label='Data de detecção')
                el-radio-group(v-model='filtro.dataDeteccao')
                    el-radio(label='1 dia')
                    el-radio.space-radio(label='7 dias')
                    el-radio.space-radio(label='30 dias')
                    el-radio.space-radio(label='90 dias')
            el-form-item
                el-button.limpar(icon='el-icon-delete', @click='limparFiltro') Limpar

        .restricoes(v-if='totalAlertas > 0')
            el-table(
                ref='tabelaRestricoes',
                :data='alertas',
                stripe,
                style='width: 100%',
                @row-click='expandirLinha',
                @expand-change='mostrarAlertaNoMapa'
            )
                el-table-column(label='Tipo')
                    template(slot-scope='scope')
                        span
                            | {{ scope.row.tipoOperacao.codigo === 'INCONFORME' ? 'Entrada/Atualização' : 'Saída' }}
                el-table-column(label='Data de detecção', prop='dataCadastro')
                el-table-column(label='Restrições', align='right', width='150')
                    template(slot-scope='scope')
                        span
                            | {{ quantidadeRestricao(scope.row.restricoes) }}

                el-table-column(type='expand', width='90')
                    template(slot-scope='scope')
                        Mapa.mapa(
                            height='400px',
                            :mapLayersConfigs='layersMaps',
                            :mapConfig='mapConfig',
                            :addLimitesEstado='true',
                            :idMapa='`mapaModalAlertasSocioambientais_${scope.row.idAlerta}`'
                        )
                template(slot='empty')
                el-empty(description='Não há alertas socioambientais!')

            footer(style='text-align: center; margin-top: 10px !important')
                el-pagination(
                    background,
                    :page-size='paginacao.tamPagina',
                    :current-page.sync='paginacao.paginaAtual + 1',
                    layout='prev, pager, next',
                    :total='totalAlertas',
                    @current-change='atualizarPagina'
                )
</template>

<script>
import Mapa from '@/components/alertas/MapaAlertasSocioambientais.vue';

import AlertaService from '@/services/AlertaService';
import AreasMonitoradasService from '@/services/AreasMonitoradasService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
    name: 'ModalAlertasSocioambientais',

    props: {
        show: {
            default: false,
            type: Boolean
        }
    },

    emits: ['close'],

    components: {
        Mapa
    },

    mounted() {},

    data() {
        return {
            filtro: {
                tipo: '',
                dataDeteccao: null,
                camadas: []
            },
            alertas: [],
            camadas: [],
            alertaAberto: [],
            mapConfig: {
                controls: {
                    zoomControl: true
                }
            },
            layersMaps: [],
            geometriaAreaMonitorada: {},
            bufferGeometriaRestricoes: {},
            geometriaAlertaAberto: {},
            totalAlertas: 0,
            paginacao: {
                tamPagina: 10,
                paginaAtual: 0
            }
        };
    },

    watch: {
        show: function () {
            if (this.show) {
                this.findAlertas();
            }
        },
        'filtro.tipo': function () {
            this.findAlertas();
        },

        'filtro.dataDeteccao': function () {
            this.findAlertas();
        },

        'filtro.camadas': function () {
            this.findAlertas();
        },

        alertas: function () {
            if (this.alertas.length > 0) {
                this.buscarAreaMonitorada();
            }
        }
    },

    methods: {
        findAlertas() {
            const filtros = this.filtrar();
            AlertaService.findAlertas(
                this.$route.params.idAreaMonitorada,
                filtros,
                this.paginacao
            )
                .then(({ data }) => {
                    this.alertas = data.alertas;
                    this.totalAlertas = data.totalItens;
                    this.findCamadas();
                })
                .catch(erro => {
                    this.$notify.error({
                        message: `Ocorreu um erro ao buscar os alertas - ${erro}`
                    });
                });
        },

        closeModal() {
            this.$emit('close');
        },

        limparFiltro() {
            this.filtro = {
                tipo: '',
                dataDeteccao: null,
                camadas: []
            };
            this.findAlertas();
        },

        filtrar() {
            let codigoTipoOperacao =
                this.filtro.tipo === 'Entrada/Atualização' ||
                this.filtro.tipo === ''
                    ? 'INCONFORME'
                    : 'CONFORME';

            // eslint-disable-next-line no-extend-native
            Date.prototype.ajustarDataInicial = function (dias) {
                let date = new Date(this.valueOf());
                date.setDate(date.getDate() - dias);
                return date;
            };

            let dataCadastroInicial = new Date();
            switch (this.filtro.dataDeteccao) {
                case '1 dia':
                    dataCadastroInicial =
                        dataCadastroInicial.ajustarDataInicial(1);
                    break;

                case '7 dias':
                    dataCadastroInicial =
                        dataCadastroInicial.ajustarDataInicial(7);
                    break;

                case '30 dias':
                    dataCadastroInicial =
                        dataCadastroInicial.ajustarDataInicial(30);
                    break;

                case '90 dias':
                    dataCadastroInicial =
                        dataCadastroInicial.ajustarDataInicial(90);
                    break;

                default:
                    dataCadastroInicial =
                        dataCadastroInicial.ajustarDataInicial(90);
                    break;
            }

            return {
                codigoTipoOperacao,
                dataCadastroInicial,
                dataCadastroFinal: new Date(),
                camadas: this.filtro.camadas
            };
        },

        buscarAreaMonitorada() {
            if (this.geometriaAreaMonitorada !== {}) {
                AreasMonitoradasService.findById(
                    this.$route.params.idAreaMonitorada
                )
                    .then(({ data }) => {
                        this.geometriaAreaMonitorada = data.geometria;
                    })
                    .catch(erro => {
                        this.$notify.error({
                            message:
                                'Não foi possível buscar mapa da área monitorada ' +
                                erro
                        });
                    });
            }
        },

        expandirLinha(row) {
            this.$refs.tabelaRestricoes.toggleRowExpansion(row);
        },

        mostrarAlertaNoMapa(alerta, expanded) {
            if (expanded.length) {
                this.geometriaAlertaAberto = [];
                alerta.restricoes.forEach(r => {
                    if (r.geometria) {
                        this.geometriaAlertaAberto.push(r.geometria);
                    }
                });
                setTimeout(this.atualizarMapa(), 500);
            }
        },

        atualizarMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: getEstiloGeometria('area'),
                name: 'AreaMonitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            let layerRestricaoAlerta = {
                style: {
                    weight: 2,
                    fill: true,
                    fillOpacity: 0.3,
                    color: 'red'
                },
                name: 'Alerta',
                geoJson: this.geometriaAlertaAberto
            };

            this.layersMaps.push(layerRestricaoAlerta);
        },

        atualizarPagina(pagina) {
            this.paginacao.paginaAtual = pagina - 1;
            this.findAlertas();
        },

        findCamadas() {
            AlertaService.findCamadas(this.$route.params.idAreaMonitorada).then(
                ({ data }) => {
                    this.camadas = data;
                }
            );
        },
        quantidadeRestricao(restricoes) {
            if (restricoes.length === 1) {
                return '1 restrição';
            }

            return `${restricoes.length} restrições`;
        }
    }
};
</script>

<style lang="scss">
#modal-alertas-socioambientais {
    form {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        column-gap: 30px;

        .el-form-item__label {
            padding: 0;
            margin-bottom: -10px;
            font-weight: 600;
        }
    }
    .el-dialog__wrapper {
        top: -15px !important;
        margin: 0 0 10px 35px !important;

        .el-dialog {
            margin-top: 90px !important;
        }
    }

    .restricoes {
        .el-table__body-wrapper {
            max-height: calc(100vh - 90px - 54px - 62px - 88px - 35px);
            overflow-y: scroll;
        }
        .mapa {
            padding-right: 8px !important;
            overflow: hidden;
        }
    }

    .limpar {
        height: 40px;
        margin-top: 40px;
    }

    .space-radio {
        padding-left: 8px;
    }

    .aviso {
        display: flex;
        align-items: center;
        padding: 4px 10px;
        margin-bottom: 24px;
        text-align: center;

        background-color: #fffce8;
        border: 1px solid #ffc400;
        border-radius: 4px;

        i {
            font-size: 24px;
            margin: -4px 8px -7px 0px;
        }

        p {
            padding: 10px 10px 0px 25px;
            word-break: break-word;
        }
    }
}
</style>
